export const USER_TYPES_IDS = {
  HP: 'ca87c666-32f9-493e-8dc6-81b523c1e794',
};
